import useSWR, { SWRResponse } from 'swr';
import { getCompany } from '../../../providers/api/company/companyProvider';
import { Company } from '../../../providers/api/dtos';

export const getUseCompanyRid = (idOrVat: string | number) => ['/api/v1/companies', idOrVat.toString()];

export default function useCompany(idOrVat?: string | number): SWRResponse<Company, Error> {
  return useSWR(idOrVat ? getUseCompanyRid(idOrVat) : null, () => getCompany(idOrVat!));
}
